var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcIos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "31px",
    viewBox: "0 0 30 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-ios") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download-Copy",
    transform: "translate(-445.000000, -621.000000)",
    fill: "#0FA44A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HERO",
    transform: "translate(-546.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email-Form",
    transform: "translate(948.000000, 537.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Imported-Layers-2",
    transform: "translate(43.000000, 7.910156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6886857,6.24880952 C23.9314286,6.24880952 26.0050286,9.38633333 26.0050286,9.38633333 C26.0050286,9.38633333 22.8418286,11.1028571 22.8418286,14.8307381 C22.8418286,19.2553095 26.8155429,20.5423571 26.8155429,20.5423571 C26.8155429,20.5423571 23.6790857,27.9843095 20.1572571,27.9843095 C18.1769143,27.9843095 18.0445714,26.8450238 15.4128,26.8450238 C13.1273143,26.8450238 12.3565714,27.9843095 10.6155429,27.9843095 C7.29257143,27.9843095 3,20.7301667 3,14.8307381 C3,8.7027619 7.34605714,6.24880952 10.0704,6.24880952 C12.4628571,6.24880952 13.4592,7.65669048 15.3860571,7.65669048 C17.0077714,7.65669048 18.2838857,6.24880952 20.6886857,6.24880952 L20.6886857,6.24880952 Z M20.1312,0 C20.6091429,3.00357143 17.8848,6.71833333 14.6290286,6.5975 C14.1504,2.77571429 17.6592,0.201619048 20.1312,0 L20.1312,0 Z",
    id: "Imported-Layers"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIos);
export default __webpack_public_path__ + "static/media/ic-ios.9e0598416b6a44ed456e8e1ac7fe6eca.svg";
export { ForwardRef as ReactComponent };